import { createTheme } from "@mui/material/styles";
import type { BrandTokens } from "../types";

export const createAtlasTheme = (brand: BrandTokens) =>
  createTheme({
    palette: {
      mode: "light",
      primary: { main: "#0f4c5c" },
      secondary: { main: "#8a5a44" },
      warning: { main: "#e09f3e" },
      background: { default: "#f6f1e9", paper: "#ffffff" },
      text: { primary: "#1d1a17", secondary: "rgba(29, 26, 23, 0.68)" }
    },
    shape: { borderRadius: brand.radius + 4 },
    typography: {
      fontFamily: "\"Space Grotesk\", \"Segoe UI\", sans-serif",
      h1: {
        fontFamily: "\"Fraunces\", \"Times New Roman\", serif",
        fontWeight: 600,
        letterSpacing: "-0.02em",
        fontSize: "clamp(2.5rem, 4.4vw, 3.6rem)"
      },
      h2: {
        fontFamily: "\"Fraunces\", \"Times New Roman\", serif",
        fontWeight: 600,
        fontSize: "clamp(1.9rem, 3.1vw, 2.6rem)"
      },
      h3: { fontWeight: 600, fontSize: "clamp(1.4rem, 2.4vw, 2rem)" },
      body1: { fontSize: "1rem", lineHeight: 1.75 },
      body2: { fontSize: "0.95rem", lineHeight: 1.75 },
      button: { textTransform: "none", fontWeight: 600 }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ":root": {
            "--app-bg": "#f6f1e9",
            "--app-surface": "#ffffff",
            "--app-primary": "#0f4c5c",
            "--app-accent": "#e09f3e"
          },
          body: {
            backgroundColor: "#f6f1e9",
            backgroundImage:
              "radial-gradient(1000px 500px at 12% -10%, rgba(224, 159, 62, 0.18), transparent 65%)," +
              "radial-gradient(900px 450px at 90% 10%, rgba(15, 76, 92, 0.14), transparent 60%)," +
              "linear-gradient(180deg, #f9f4ed 0%, #f3ede3 60%, #f7f1e8 100%)",
            color: "#1d1a17"
          },
          "#root": {
            minHeight: "100vh",
            animation: "fadeRise 420ms ease-out"
          },
          "@keyframes fadeRise": {
            from: { opacity: 0, transform: "translateY(6px)" },
            to: { opacity: 1, transform: "translateY(0)" }
          }
        }
      },
      MuiAppBar: {
        defaultProps: { color: "transparent", elevation: 0 }
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: "none", boxShadow: "0 14px 30px rgba(29, 26, 23, 0.08)" }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: brand.radius + 4, padding: "10px 22px" },
          outlined: ({ theme }) => ({
            borderColor: "rgba(15, 76, 92, 0.4)",
            color: theme.palette.primary.main,
            "&:hover": {
              borderColor: theme.palette.primary.main,
              backgroundColor: "rgba(15, 76, 92, 0.08)"
            }
          })
        }
      },
      MuiLink: {
        styleOverrides: { root: { textDecoration: "none", fontWeight: 500 } }
      }
    }
  });
